export const materialRouter = [
    {
      path: '/material/basics/warehousing',
      name: 'page_material_warehousing',
      component: () => import('../../views/material/warehousing/index'),
    },
    {
      path: '/material/basics/warehouse-out',
      name: 'page_material_warehouse_out',
      component: () => import('../../views/material/warehouse-out/index'),
    },
    {
      path: '/material/basics/move-storehouse',
      name: 'page_material_move_storehouse',
      component: () => import('../../views/material/move-storehouse/index'),
    },
    {
      path: '/material/basics/check',
      name: 'page_material_check',
      component: () => import('../../views/material/check/index.vue'),
    },
    // {
    //   path: '/material/basics/statistical_report',
    //   name: 'page_material_statistical_report',
    //   component: () => import('../../views/material/statistical-report/index'),
    // },
  ]
